import { useState } from 'react'

import { useTrace } from '@/hooks'
import { useStoreDispatch } from '@/store/hooks'
import { generateReport } from '@/store/report-templates/thunks'

export function useReportGeneration() {
  const dispatch = useStoreDispatch()
  const [isGenerating, setIsGenerating] = useState(false)
  const [report, setReport] = useState('')
  const [traceUrl, setTraceUrl] = useState<string | undefined>(undefined)

  const clearReport = () => {
    setReport('')
  }

  const handleGenerateReport = async (instructions: string) => {
    setIsGenerating(true)
    clearReport()

    const res = await dispatch(
      generateReport({
        instructions,
      }),
    ).unwrap()

    setTraceUrl(res.traceUrl)
    setReport(res.report)
    setIsGenerating(false)
  }

  const { Trace } = useTrace({ traceUrl })
  return {
    clearReport,
    generateReport: handleGenerateReport,
    isGenerating,
    report,
    Trace,
  }
}
